/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

export type FolderChatStatus = typeof FolderChatStatus[keyof typeof FolderChatStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FolderChatStatus = {
  DRAFT: 'DRAFT',
  PROCESSING: 'PROCESSING',
  COPYING: 'COPYING',
  COMPLETE: 'COMPLETE',
  ERROR: 'ERROR',
  UPDATING: 'UPDATING',
} as const;
